<script>
import VaultGame from "@/components/vault-preview/VaultGame.vue";

export default {
  name: "VaultPreview",
  components: {
    VaultGame
  }
};
</script>

<template>
  <VaultGame />
</template>
